<template>
  <div class="register-page">
    <div class="register-framework">
      <el-container class="register-container">
        <el-header class="header">
          <img src="/static/login/logo.png" height="80px"/>
        </el-header>
        <el-main class="main">
          <el-card shadow="always" class="form-box" :body-style="{ padding:'20px'}">
            <div class="card-body">
              <div class="user">
                <p class="name">用户名
                  <span class="warn">{{ userWarn }}</span>
                </p>
                <el-input size="large" v-model="user" class="input-box" placeholder="4到16位，仅允许大小写字母和下划线"></el-input>
                <p class="name">电子邮箱
                  <span class="warn">{{ emailWarn }}</span>
                </p>
                <el-input size="large" v-model="email" class="input-box" placeholder="blackbox@exmaple.com"></el-input>
              </div>
              <div class="pwd">
                <!--密码禁止复制粘贴-->
                <p class="name">密码
                  <span class="warn">{{ pwdWarn }}</span>
                </p>
                <el-input size="large" v-model="pwd" class="input-box" type="password"
                          placeholder="至少6位，同时包含大、小写字母和数字" onpaste="return false" oncontextmenu="return false"
                          oncopy="return false" oncut="return false"></el-input>
                <p class="name">再次输入密码
                  <span class="warn">{{ pwdAgainWarn }}</span>
                </p>
                <el-input size="large" v-model="pwdAgain" class="input-box" type="password"
                          placeholder="请与上方保持一致" onpaste="return false" oncontextmenu="return false"
                          oncopy="return false" oncut="return false"></el-input>
              </div>
              <el-button type="primary" class="login-button" @click="toLogin">
                <span style="font-size:14px">提交注册信息</span>
              </el-button>
            </div>
          </el-card>
        </el-main>
        <el-footer class="bottom">
          <el-card shadow="always" :body-style="{ padding:'15px'}">
            <span class="bottom-text">
            <a href="/#/login" target="_parent" title="返回登录界面" style="font-size: 14px;color:#2258cc">返回登录界面</a>
            </span>
          </el-card>
        </el-footer>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data() {
    return {
      user: '',
      email: '',
      pwd: '',
      pwdAgain: '',
      userWarn: '',
      emailWarn: '',
      pwdWarn: '',
      pwdAgainWarn: '',
    };
  },
  mounted() {
  },
  methods: {
    toLogin() {
      const self = this;
      const { user, email, pwd, pwdAgain } = this;
      self.userWarn = '';
      self.emailWarn = '';
      self.pwdWarn = '';
      if (user === '') {
        self.userWarn = '请输入用户名';
      } else if (self.isUser(user) === false) {
        self.userWarn = '4到16位，仅允许大小写字母和下划线';
      } else if (email === '') {
        self.emailWarn = '请输入电子邮箱';
      } else if (self.isEmail(email) === false) {
        self.emailWarn = '请输入正确的电子邮箱';
      } else if (pwd === '') {
        self.pwdWarn = '请输入密码';
      } else if (self.isPwd(pwd) === false) {
        self.pwdWarn = '6位以上，请务必包含大写字母、小写字母以及数字';
        self.pwd = '';
        self.pwdAgain = '';
      } else if (pwdAgain === '') {
        self.pwdAgainWarn = '请再次输入密码';
      } else if (pwdAgain !== pwd) {
        self.pwdAgainWarn = '两次密码输入不一致，请重新输入';
        self.pwd = '';
        self.pwdAgain = '';
      } else {
        self.$message({
          type: 'success',
          message: `你的信息已经提交，等待管理员进行审核，结果将以邮件告知${email}`,
        });
        this.$router.push('/');
      }
    },
    isUser(user) {
      const filter = /^[a-zA-Z0-9_]{4,16}$/;
      if (filter.test(user)) {
        return true;
      }
      return false;
    },
    isEmail(mail) {
      const filter = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      if (filter.test(mail)) {
        return true;
      }
      return false;
    },
    isPwd(pwd) {
      const filter = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
      if (filter.test(pwd)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
  @import "../style/mixin";
  @import '../style/media';

  .register-page {
    width: 100%;
    height: 100%;
    background-image: url('/static/login/demo.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    -webkit-box-orient: vertical;
    @include focus-scroll-bar;

    .register-container {
      margin-left: auto;
      margin-right: auto;
      background: #fff;
      width: 450px;
      height: 750px;
      display: flex;
      align-items: center;
      vertical-align: center;
      justify-content: center;
      overflow-x: auto;

      .header {
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-box-orient: vertical;
        text-align: center;
        height: 120px !important;
      }

      .main {
        padding: 0 !important;
        background: #fff;
        @include focus-scroll-bar;

        .form-box {
          width: 400px;
          height: 500px;
        }

        .card-body {
          padding: 0 !important;

          .name {
            margin-top: 8px;
            margin-bottom: 8px;
            font-size: 14px;
          }

          .input-box {
            margin-bottom: 20px;
          }

          .login-button {
            width: 100% !important;
            margin-top: 30px;
          }

          .warn {
            color: red;
            font-weight: bold;
            float: right;
          }
        }
      }

      .bottom {
        margin-top: 20px;
        width: 400px !important;
        height: 100px!important;
        padding: 0 !important;

        .bottom-text {
          display: -webkit-box;
          -webkit-box-pack: center;
          -webkit-box-align: center;
          -webkit-box-orient: vertical;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/register.vue